<template>
  <div :class="$style.card">
    <div :class="$style.up_wrapper">
      <the-uploader
        :class="$style.uploder"
        ref="uploader"
        :uploader="uploader"
        @update="setUploadImg"
        @identifyData="getIdentifyData"
      ></the-uploader>
      <div :style="{ 'z-index': isUp ? -1 : 99 }" :class="[$style.card_info]">
        <div :class="$style.info">
          <p>姓名：{{ cardInfo.name }}</p>
          <p>性别：{{ cardInfo.sex ? "女" : "男" }}</p>
          <p>身份证号：{{ cardInfo.id_code }}</p>
        </div>
        <p
          :class="[
            $style.photo,
            cardInfo.sex != 1 ? $style.photo_man : $style.photo_woman
          ]"
        ></p>
        <p :class="$style.again_up" @click="againUp">
          信息有误？<span>点击重新上传</span>
        </p>
      </div>
    </div>

    <div :class="$style.agree">
      <van-checkbox v-model="checked" icon-size="14px"></van-checkbox
      >同意将身份信息用于本次申诉工单
    </div>
    <van-button
      round
      :disabled="!checked"
      type="primary"
      size="large"
      tag="input"
      value="提交"
      native-type="submit"
      @click.stop.prevent="onSubmit"
    />
    <div :class="$style.require" v-if="isUp"></div>
  </div>
</template>
<script>
import TheUploader from "@/components/TheUploader";
import { getIdentifyData } from "@/http/serve";
export default {
  name: "idCard",
  components: {
    TheUploader
  },
  data() {
    return {
      checked: true, //是否同意
      cardInfo: this.$ls.get("cardInfo", {}), //身份证识别新
      uploadImg: [], //身份证图片
      uploader: {
        //图片上传初始化
        count: 1,
        text: "点击上传身份证人像面",
        reqiure: true,
        isCard: true
      }
    };
  },
  computed: {
    isUp() {
      return Object.keys(this.cardInfo).length == 0;
    }
  },
  methods: {
    againUp() {
      this.$refs.uploader.clearImg();
      this.cardInfo = {};
      this.$ls.set("cardInfo", this.cardInfo);
    },
    chagneAgree(val) {
      this.checked = val;
    },
    /**
     * @description 上传身份证图片
     * @param {string} val  - 图片地址
     */
    setUploadImg(val) {
      //重置身份证信息
      this.cardInfo = {};
      this.$ls.set("cardInfo", this.cardInfo);
      this.uploadImg = val;
    },
    /**
     * @description 自动识别身份证信息
     * @param {string} filepath  - 图片地址
     */
    async getIdentifyData(filepath, base64Img, url) {
      base64Img = base64Img.replace(/^data:image\/\w+;base64,/, "");
      let parmas = {
        filepath,
        cache_id: this.$ls.get("cacheId"),
        base64Img
      };
      let res = await getIdentifyData(parmas);

      if (res.rcode == 0) {
        let {
          data: { id_code, name, sex }
        } = res;

        this.cardInfo = {
          id_code,
          name,
          sex,
          pic_id_code: url
        };
        this.$ls.set("cardInfo", this.cardInfo);
      } else if (res.rcode == 6002) {
        this.$parent.resetData();
      } else {
        this.againUp();
      }
    },
    /**
     * @description 提交身份证信息
     */
    onSubmit() {
      if (!this.checked) {
        this.$Toast("您为同意上传身份证");
        return false;
      }
      if (Object.keys(this.cardInfo).length == 0) {
        this.$Toast("请点击上传身份证人像面");
        return false;
      }
      this.$parent.getAppeal(3, this.cardInfo);
    }
  }
};
</script>
<style lang="less" module>
.up_wrapper {
  .size(6.4rem, 4.3rem);
  position: relative;
  .uploder {
    position: absolute;
    :global {
      .van-uploader {
        .size(6.4rem, 4.3rem);
        background-color: #ffffff;
        background: url("./image/bg.png");
        background-size: 100% 100%;
        box-shadow: 0 0 0.01rem 0 rgba(14, 5, 10, 0.06);
        border-radius: 0.1rem;
        margin: 0;
      }
      .van-uploader__upload {
        .size(6.4rem, 4.3rem);
        background-color: transparent;
        margin: 0;
      }
      .van-uploader__upload-icon {
        font-size: 0;
      }
    }
  }
  .card_info {
    .size(6.4rem, 4.3rem);
    position: absolute;
    position: relative;
    background: url("./image/card_bg.png");
    background-size: 100% 100%;
    box-shadow: 0 0 0.01rem 0 rgba(14, 5, 10, 0.06);
    .info {
      height: 2.5rem;
      position: absolute;
      left: 1rem;
      top: 0.6rem;
      padding: 0 0.3rem;
      p {
        width: 3.8rem;
        font-size: 0.24rem;
        text-align: left;
        color: #222222;
        margin-top: 0.4rem;
      }
    }
    .photo {
      .size(1.08rem, 1.25rem);
      background: url("./image/sex.png");
      background-size: 200% 100%;
      position: absolute;
      right: 1.5rem;
      top: 0.8rem;
      &_man {
        background-position: 100% 0%;
      }
      &_woman {
        background-position: 0% 0%;
      }
    }
  }
}
.card {
  .flex-col;
  .flex-align-center;
  position: relative;
  :global {
    .van-button {
      margin-top: 0.7rem;
    }
  }
}
.again_up {
  .size(4.5rem, 0.6rem);
  position: absolute;
  right: 0.9rem;
  bottom: 0.4rem;
  font-size: 0.3rem;
  line-height: 0.6rem;
  text-align: center;
  span {
    color: #1b8cff;
  }
}
.require {
  .size(6.29rem, 2rem);
  background: url("./image/require.png");
  background-size: 100% 100%;
  margin-top: 0.75rem;
}
.agree {
  .flex-row;
  font-size: 0.24rem;
  color: #222222;
  margin-top: 0.2rem;
  :global {
    .van-checkbox {
      margin-right: 0.11rem;
    }
  }
}
.tip {
  position: absolute;
  left: 1.1rem;
  bottom: 0.5rem;
  width: 4.2rem;
  font-size: 0.32rem;
  color: #222222;
  text-align: center;
  pointer-events: none;
  span {
    color: #1b8cff;
  }
}
</style>
